<div
  class="ui segment"
  appMargin
  marginB="3"
  fxLayout="row"
  fxLayoutGap="10px"
  fxLayoutAlign="start stretch"
  [formGroup]="templateForm"
>
  <!-- <div fxFlex="5%">
    <sui-checkbox> </sui-checkbox>
  </div> -->
  <div fxFlex="25%">{{ template?.messageTemplateName }}</div>
  <div fxFlex="grow">{{ template?.messageTemplateDescription }}</div>
  <div fxFlex="15%">
    <sui-checkbox class="toggle" formControlName="email">
      {{ template.emailEnabled ? "Enabled" : "Disabled" }}
    </sui-checkbox>
  </div>
  <div fxFlex="15%">
    <sui-checkbox class="toggle" formControlName="sms">
      {{ template.smsEnabled ? "Enabled" : "Disabled" }}
    </sui-checkbox>
  </div>
  <div fxFlex="10%" class="text-right">
    <button
      *isPermitted="{ id: 'MESSAGE_TEMPLATE', action: 'edit' }"
      class="ui circular tiny button"
      (click)="onEdit.emit(template)"
      suiPopup
      [popupInverted]="true"
      popupPlacement="bottom"
      popupText="Edit Template"
    >
      <i class="pencil icon"></i>
    </button>
    <a
      *isPermitted="{ id: 'MESSAGE_TEMPLATE', action: 'read' }"
      class="ui circular tiny button"
      routerLink="/admin/setting/message-template/detail/{{
        template.messageTemplateId
      }}"
      suiPopup
      [popupInverted]="true"
      popupPlacement="bottom"
      popupText="View Template"
      ><i class="eye icon"></i
    ></a>
    <!-- <button *isPermitted="{id:'MESSAGE_TEMPLATE',action:'edit'}"  class="ui circular tiny button" (click)="onDelete.emit(template)"><i class="trash icon"></i></button> -->
  </div>
</div>
